// extracted by mini-css-extract-plugin
export default {"collect":"collect__rwAzJ","info":"info__20zii","submit":"submit__IJYgR"};